module.exports = __webpack_public_path__ + "static/media/Sopian.b6d978c2.jpeg";